export const DIAGNOSIS_STATIC="/diagnosis/static";
export const DIAGNOSIS_DYNAMIC="/diagnosis/dynamic";
export const DIAGNOSIS_DYNAMIC_STATUS="/diagnosis/dynamic/status";
export const DIAGNOSIS_HISTORY="/diagnosis/history";
export const DIAGNOSIS_DYNAMIC_RESULT="/diagnosis/dynamic/result";
export const DIAGNOSIS_STATIC_RESULT="/diagnosis/static/result";
export const DIAGNOSIS_REPORT="/diagnosis/report";